exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "\n.chartChecks[data-v-0b6422cd] {\n  margin: 20px 0;\n}\nlabel[data-v-0b6422cd] {\n  font-size: 11px;\n}\ninput[data-v-0b6422cd] {\n  position: relative;\n  top: 2px;\n}\n", ""]);

